export const getInitials = (str) => {
    const words = str.trim().split(/\s+/);
    let initials = words[0][0];
    if (words.length > 1) {
        initials += words[words.length - 1][0];
    }
    return initials.toUpperCase();
};
